import { DAYLIGHT, DAYLIGHT_CYCLE_MS } from '../data/daylight.js';
/**
 * The time of day (ADR 0093): where a wall-clock time falls in the cycle and
 * how dark it is there. Nothing stored: the server and every client give the
 * same answer from `Date.now()`, as `eventSlotOf` does for the events.
 */
export const DAY_PHASES = ['dawn', 'day', 'dusk', 'night'];
/** The darkness changes by steps: a few redraws per twilight, never one per frame. */
export const DARKNESS_STEPS = 24;
const PHASE_LENGTHS = Object.freeze({
    dawn: DAYLIGHT.dawnMs,
    day: DAYLIGHT.dayMs,
    dusk: DAYLIGHT.duskMs,
    night: DAYLIGHT.nightMs,
});
function stepped(fraction) {
    return Math.round(Math.min(1, Math.max(0, fraction)) * DARKNESS_STEPS) / DARKNESS_STEPS;
}
export function timeOfDay(now) {
    const cycleStart = Math.floor(now / DAYLIGHT_CYCLE_MS) * DAYLIGHT_CYCLE_MS;
    let start = cycleStart;
    for (const phase of DAY_PHASES) {
        const length = PHASE_LENGTHS[phase];
        const end = start + length;
        if (now < end) {
            const through = (now - start) / length;
            const darkness = phase === 'dawn'
                ? stepped(1 - through)
                : phase === 'dusk'
                    ? stepped(through)
                    : phase === 'night'
                        ? 1
                        : 0;
            return { phase, darkness, phaseEndsAt: end };
        }
        start = end;
    }
    // Unreachable: the four phases fill the cycle.
    return {
        phase: 'dawn',
        darkness: 1,
        phaseEndsAt: cycleStart + DAYLIGHT_CYCLE_MS + DAYLIGHT.dawnMs,
    };
}
/** Whether the creatures of the night are out: the full night only, twilights excluded. */
export function isNight(now) {
    return timeOfDay(now).phase === 'night';
}
//# sourceMappingURL=daylight.js.map